module.exports = {
	"_args": [
		[
			"tough-cookie@~2.3.0",
			"/Users/lucasseidenfaden/www/rwi/vagrant/node_modules/request"
		]
	],
	"_from": "tough-cookie@>=2.3.0 <2.4.0",
	"_id": "tough-cookie@2.3.2",
	"_inCache": true,
	"_installable": true,
	"_location": "/tough-cookie",
	"_nodeVersion": "7.0.0",
	"_npmOperationalInternal": {
		"host": "packages-12-west.internal.npmjs.com",
		"tmp": "tmp/tough-cookie-2.3.2.tgz_1477415232912_0.6133609430398792"
	},
	"_npmUser": {
		"email": "jstash@gmail.com",
		"name": "jstash"
	},
	"_npmVersion": "3.10.8",
	"_phantomChildren": {},
	"_requested": {
		"name": "tough-cookie",
		"raw": "tough-cookie@~2.3.0",
		"rawSpec": "~2.3.0",
		"scope": null,
		"spec": ">=2.3.0 <2.4.0",
		"type": "range"
	},
	"_requiredBy": [
		"/request"
	],
	"_resolved": "https://registry.npmjs.org/tough-cookie/-/tough-cookie-2.3.2.tgz",
	"_shasum": "f081f76e4c85720e6c37a5faced737150d84072a",
	"_shrinkwrap": null,
	"_spec": "tough-cookie@~2.3.0",
	"_where": "/Users/lucasseidenfaden/www/rwi/vagrant/node_modules/request",
	"author": {
		"email": "jstashewsky@salesforce.com",
		"name": "Jeremy Stashewsky"
	},
	"bugs": {
		"url": "https://github.com/salesforce/tough-cookie/issues"
	},
	"contributors": [
		{
			"name": "Alexander Savin"
		},
		{
			"name": "Ian Livingstone"
		},
		{
			"name": "Ivan Nikulin"
		},
		{
			"name": "Lalit Kapoor"
		},
		{
			"name": "Sam Thompson"
		},
		{
			"name": "Sebastian Mayr"
		}
	],
	"dependencies": {
		"punycode": "^1.4.1"
	},
	"description": "RFC6265 Cookies and Cookie Jar for node.js",
	"devDependencies": {
		"async": "^1.4.2",
		"string.prototype.repeat": "^0.2.0",
		"vows": "^0.8.1"
	},
	"directories": {},
	"dist": {
		"shasum": "f081f76e4c85720e6c37a5faced737150d84072a",
		"tarball": "https://registry.npmjs.org/tough-cookie/-/tough-cookie-2.3.2.tgz"
	},
	"engines": {
		"node": ">=0.8"
	},
	"files": [
		"lib"
	],
	"gitHead": "2610df5dc8ef7373a483d509006e5887572a4076",
	"homepage": "https://github.com/salesforce/tough-cookie",
	"keywords": [
		"HTTP",
		"RFC2965",
		"RFC6265",
		"cookie",
		"cookiejar",
		"cookies",
		"jar",
		"set-cookie"
	],
	"license": "BSD-3-Clause",
	"main": "./lib/cookie",
	"maintainers": [
		{
			"name": "awaterma",
			"email": "awaterma@awaterma.net"
		},
		{
			"name": "jstash",
			"email": "jstash@gmail.com"
		},
		{
			"name": "nexxy",
			"email": "emily@contactvibe.com"
		}
	],
	"name": "tough-cookie",
	"optionalDependencies": {},
	"readme": "ERROR: No README data found!",
	"repository": {
		"type": "git",
		"url": "git://github.com/salesforce/tough-cookie.git"
	},
	"scripts": {
		"suffixup": "curl -o public_suffix_list.dat https://publicsuffix.org/list/public_suffix_list.dat && ./generate-pubsuffix.js",
		"test": "vows test/*_test.js"
	},
	"version": "2.3.2"
};


//////////////////
// WEBPACK FOOTER
// ./~/tough-cookie/package.json
// module id = 919
// module chunks = 0